(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  var NEED_PARAM = 'sa_need';
  var activeNeedSlug = '';
  var collectionState = {
    activeNeed: '',
    selectorOpen: false,
    selectorMode: '',
    presetProductIds: [],
    nativeFilterState: '',
    sortState: '',
    collectionHandle: ''
  };

  function initPopularCarousel(root) {
    var track = root.querySelector('[data-sa-popular-track]');
    var prev = root.querySelector('[data-sa-popular-prev]');
    var next = root.querySelector('[data-sa-popular-next]');
    if (!track || !prev || !next) return;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function update() {
      var max = maxScroll();
      var canScroll = max > 4;
      root.classList.toggle('is-carousel-ready', canScroll);
      prev.hidden = !canScroll;
      next.hidden = !canScroll;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }

    function scrollByPage(direction) {
      track.scrollBy({
        left: direction * Math.max(220, track.clientWidth * 0.88),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { scrollByPage(-1); });
    next.addEventListener('click', function () { scrollByPage(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    window.setTimeout(update, 0);
    window.setTimeout(update, 400);
  }

  function collectionHandle() {
    var explicit = document.querySelector('[data-sa-collection-products][data-sa-collection-handle], [data-sa-collection-selector][data-collection-handle], [data-sa-need-shortcuts][data-sa-collection-handle]');
    if (explicit) {
      return explicit.getAttribute('data-sa-collection-handle') || explicit.getAttribute('data-collection-handle') || '';
    }
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function presetDataForCurrentCollection() {
    var data = window.SA_COLLECTION_NEED_PRESETS;
    var handle = collectionHandle();
    if (!data || !data.collections || !handle) return null;
    return data.collections[handle] || null;
  }

  function presetForIntent(intent) {
    var data = presetDataForCurrentCollection();
    return data && data.needs && intent ? data.needs[intent] || null : null;
  }

  function presetHasProducts(preset) {
    return Boolean(preset && (
      (Array.isArray(preset.rankedProductIds) && preset.rankedProductIds.length) ||
      (Array.isArray(preset.rankedProductHandles) && preset.rankedProductHandles.length)
    ));
  }

  function isPresetCollection() {
    return Boolean(presetDataForCurrentCollection());
  }

  function isPresetIntent(intent) {
    return isPresetCollection() && intent && intent !== 'not-sure' && presetHasProducts(presetForIntent(intent));
  }

  function selectorRoot() {
    return document.querySelector('[data-sa-collection-selector]');
  }

  function selectorIsOpen(root) {
    var selector = root || selectorRoot();
    return Boolean(selector && (
      selector.classList.contains('is-compact-open') ||
      selector.getAttribute('data-compact-open') === 'true'
    ));
  }

  function selectorModeFromState() {
    if (!collectionState.selectorOpen && !selectorIsOpen()) return '';
    return collectionState.selectorMode || 'help';
  }

  function currentSortState() {
    return new URLSearchParams(window.location.search).get('sort_by') || '';
  }

  function currentNativeFilterState() {
    var params = new URLSearchParams(window.location.search);
    params.delete(NEED_PARAM);
    params.delete('sort_by');
    return params.toString();
  }

  function presetProductIds(preset) {
    return (preset && Array.isArray(preset.rankedProductIds) ? preset.rankedProductIds : []).map(function (id) {
      return String(id);
    });
  }

  function syncCollectionState(partial) {
    Object.assign(collectionState, partial || {});
    collectionState.collectionHandle = collectionHandle();
    collectionState.nativeFilterState = currentNativeFilterState();
    collectionState.sortState = currentSortState();
    activeNeedSlug = collectionState.activeNeed || '';
    window.saCollectionCroState = Object.assign({}, collectionState);
  }

  function claimShortcutEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function scrollPosition() {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft || 0,
      y: window.pageYOffset || document.documentElement.scrollTop || 0
    };
  }

  function restoreScrollPosition(position) {
    if (!position) return;
    var html = document.documentElement;
    var body = document.body;
    var previousHtmlAnchor = html && html.style ? html.style.overflowAnchor : '';
    var previousBodyAnchor = body && body.style ? body.style.overflowAnchor : '';
    var restore = function () {
      window.scrollTo(position.x, position.y);
    };
    if (html && html.style) html.style.overflowAnchor = 'none';
    if (body && body.style) body.style.overflowAnchor = 'none';
    window.requestAnimationFrame(function () {
      restore();
      [0, 50, 150, 350, 700].forEach(function (delay) {
        window.setTimeout(restore, delay);
      });
      window.setTimeout(function () {
        if (html && html.style) html.style.overflowAnchor = previousHtmlAnchor;
        if (body && body.style) body.style.overflowAnchor = previousBodyAnchor;
      }, 760);
    });
  }

  function currentNeedFromUrl() {
    return new URLSearchParams(window.location.search).get(NEED_PARAM) || '';
  }

  function setNeedInUrl(slug, replace, extraState) {
    var url = new URL(window.location.href);
    if (slug) {
      url.searchParams.set(NEED_PARAM, slug);
    } else {
      url.searchParams.delete(NEED_PARAM);
    }
    var state = Object.assign({
      searchParams: url.searchParams.toString(),
      saNeed: slug || '',
      saSelectorOpen: false,
      saSelectorMode: ''
    }, extraState || {});
    if (replace) {
      window.history.replaceState(state, '', url.toString());
    } else {
      window.history.pushState(state, '', url.toString());
    }
  }

  function productGrid() {
    return document.getElementById('product-grid');
  }

  function gridItems(grid) {
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('[data-sa-product-id], [data-sa-product-handle]'));
  }

  function ensureOriginalOrder(grid) {
    if (!grid) return [];
    var items = gridItems(grid);
    if (!grid._saOriginalOrder || grid._saOriginalOrder.length !== items.length) {
      grid._saOriginalOrder = items.map(function (item, index) {
        return {
          item: item,
          index: Number(item.getAttribute('data-sa-original-index') || index)
        };
      });
    }
    return grid._saOriginalOrder;
  }

  function setItemVisible(item, visible) {
    item.classList.toggle('sa-need-preset-hidden', !visible);
    item.toggleAttribute('hidden', !visible);
    if (visible) {
      item.style.removeProperty('display');
      item.setAttribute('data-sa-preset-visible', 'true');
    } else {
      item.style.setProperty('display', 'none', 'important');
      item.removeAttribute('data-sa-preset-visible');
    }
  }

  function hasNativeSort() {
    return new URLSearchParams(window.location.search).has('sort_by');
  }

  function ensurePresetStatePanel() {
    var container = document.getElementById('ProductGridContainer');
    var grid = productGrid();
    if (!container || !grid) return null;
    var panel = container.querySelector('[data-sa-need-preset-state]');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'sa-need-preset-state';
      panel.setAttribute('data-sa-need-preset-state', '');
      panel.setAttribute('role', 'status');
      panel.setAttribute('aria-live', 'polite');
      panel.innerHTML = [
        '<div class="sa-need-preset-state__copy">',
        '<p class="sa-need-preset-state__eyebrow">Recommended for</p>',
        '<h2 class="sa-need-preset-state__title"></h2>',
        '<p class="sa-need-preset-state__count"></p>',
        '<p class="sa-need-preset-state__empty" hidden>No products in this selection match the current filters.</p>',
        '</div>',
        '<div class="sa-need-preset-state__actions">',
        '<button type="button" class="sa-need-preset-state__button sa-need-preset-state__button--secondary" data-sa-need-preset-clear>Clear selection</button>',
        '<button type="button" class="sa-need-preset-state__button sa-need-preset-state__button--primary" data-sa-need-preset-refine>Refine these results</button>',
        '</div>'
      ].join('');
      container.insertBefore(panel, grid);
    }
    return panel;
  }

  function setSelectorClosedDom() {
    var selector = selectorRoot();
    if (!selector) return false;
    if (window.saCollectionSelectorApi && typeof window.saCollectionSelectorApi.close === 'function') {
      window.saCollectionSelectorApi.close({ root: selector });
    }
    selector.classList.remove('is-compact-open');
    selector.setAttribute('data-compact-open', 'false');
    return true;
  }

  function closeSelector() {
    setSelectorClosedDom();
    syncCollectionState({
      selectorOpen: false,
      selectorMode: ''
    });
    updateShortcutState(collectionState.activeNeed);
  }

  function productCountNodes() {
    return Array.prototype.slice.call(document.querySelectorAll('#ProductCount, #ProductCountDesktop, .product-count, .mobile-facets__count'));
  }

  function updateProductCount(count) {
    var label = count + ' ' + (count === 1 ? 'product' : 'products') + ' selected from this range';
    productCountNodes().forEach(function (node) {
      if (!node.getAttribute('data-sa-original-count')) {
        node.setAttribute('data-sa-original-count', node.innerHTML.trim());
      }
      node.textContent = label;
    });
  }

  function restoreProductCount() {
    productCountNodes().forEach(function (node) {
      var original = node.getAttribute('data-sa-original-count');
      if (original) {
        node.innerHTML = original;
        node.removeAttribute('data-sa-original-count');
      }
    });
  }

  function updateShortcutState(activeSlug) {
    var presetData = presetDataForCurrentCollection();
    var selector = selectorRoot();
    var selectorOpen = collectionState.selectorOpen || selectorIsOpen(selector);
    var mode = selectorModeFromState();
    Array.prototype.slice.call(document.querySelectorAll('[data-sa-intent-shortcut]')).forEach(function (shortcut) {
      var intent = shortcut.getAttribute('data-sa-intent') || '';
      var isActive = intent && intent === activeSlug;
      var hasPreset = Boolean(presetData && presetData.needs && intent && intent !== 'not-sure' && presetHasProducts(presetData.needs[intent]));
      if (intent === 'not-sure') {
        var helpOpen = selectorOpen && mode === 'help' && !collectionState.activeNeed;
        shortcut.classList.toggle('is-selected', helpOpen);
        shortcut.setAttribute('aria-expanded', helpOpen ? 'true' : 'false');
        if (selector && selector.id) shortcut.setAttribute('aria-controls', selector.id);
        shortcut.removeAttribute('aria-pressed');
        return;
      }
      shortcut.classList.toggle('is-selected', isActive && hasPreset);
      shortcut.setAttribute('aria-pressed', isActive && hasPreset ? 'true' : 'false');
      if (intent && intent !== 'not-sure') {
        shortcut.hidden = !hasPreset;
      }
    });
  }

  function normalizeNeedShortcutRail(root) {
    var rail = root && root.querySelector('.sa-collection-need__rail');
    if (!rail) return;
    var helpShortcut = rail.querySelector('[data-sa-intent="not-sure"]');
    if (helpShortcut && helpShortcut.nextElementSibling) rail.appendChild(helpShortcut);
    if (!activeNeedSlug && !currentNeedFromUrl()) {
      window.requestAnimationFrame(function () {
        rail.scrollLeft = 0;
      });
    }
  }

  function updateFacetHiddenInputs(slug) {
    Array.prototype.slice.call(document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile')).forEach(function (form) {
      Array.prototype.slice.call(form.querySelectorAll('input[name="' + NEED_PARAM + '"]')).forEach(function (input) {
        input.remove();
      });
      if (!slug) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = NEED_PARAM;
      input.value = slug;
      form.appendChild(input);
    });
  }

  function restoreGrid(grid) {
    if (!grid) return;
    ensureOriginalOrder(grid).sort(function (a, b) {
      return a.index - b.index;
    }).forEach(function (entry) {
      setItemVisible(entry.item, true);
      grid.appendChild(entry.item);
    });
  }

  function applyPreset(slug, options) {
    var settings = Object.assign({ updateUrl: true, preserveScroll: false, closeSelector: true }, options || {});
    var preservedScroll = settings.preserveScroll ? scrollPosition() : null;
    var preset = presetForIntent(slug);
    var grid = productGrid();
    if (!presetHasProducts(preset) || !grid) return false;

    ensureOriginalOrder(grid);
    var rank = {};
    (preset.rankedProductIds || []).forEach(function (id, index) {
      rank[String(id)] = index;
    });
    (preset.rankedProductHandles || []).forEach(function (handle, index) {
      rank[String(handle)] = index;
    });

    var visibleItems = [];
    var hiddenItems = [];
    gridItems(grid).forEach(function (item) {
      var id = String(item.getAttribute('data-sa-product-id') || '');
      var handle = String(item.getAttribute('data-sa-product-handle') || '');
      var visible = Object.prototype.hasOwnProperty.call(rank, id) || Object.prototype.hasOwnProperty.call(rank, handle);
      setItemVisible(item, visible);
      if (visible) {
        visibleItems.push(item);
      } else {
        hiddenItems.push(item);
      }
    });

    if (!hasNativeSort()) {
      visibleItems.sort(function (a, b) {
        var aKey = String(a.getAttribute('data-sa-product-id') || a.getAttribute('data-sa-product-handle') || '');
        var bKey = String(b.getAttribute('data-sa-product-id') || b.getAttribute('data-sa-product-handle') || '');
        return (rank[aKey] || 0) - (rank[bKey] || 0);
      }).forEach(function (item) {
        grid.appendChild(item);
      });
      hiddenItems.forEach(function (item) {
        grid.appendChild(item);
      });
    }

    var panel = ensurePresetStatePanel();
    var count = visibleItems.length;
    if (panel) {
      panel.hidden = false;
      panel.setAttribute('data-sa-active-need', slug);
      panel.querySelector('.sa-need-preset-state__title').textContent = String(preset.displayName || slug).toLowerCase();
      panel.querySelector('.sa-need-preset-state__count').textContent = count + ' ' + (count === 1 ? 'product' : 'products') + ' selected from this range';
      panel.querySelector('.sa-need-preset-state__empty').hidden = count !== 0;
    }

    if (settings.closeSelector) setSelectorClosedDom();
    syncCollectionState({
      activeNeed: slug,
      selectorOpen: settings.closeSelector ? false : selectorIsOpen(),
      selectorMode: settings.closeSelector ? '' : selectorModeFromState(),
      presetProductIds: presetProductIds(preset)
    });
    updateProductCount(count);
    updateShortcutState(slug);
    updateFacetHiddenInputs(slug);
    if (settings.updateUrl && currentNeedFromUrl() !== slug) setNeedInUrl(slug, false);
    restoreScrollPosition(preservedScroll);
    return true;
  }

  function clearPreset(options) {
    var settings = Object.assign({ updateUrl: true, closeSelector: true }, options || {});
    var grid = productGrid();
    restoreGrid(grid);
    var panel = document.querySelector('[data-sa-need-preset-state]');
    if (panel) panel.hidden = true;
    if (settings.closeSelector) setSelectorClosedDom();
    syncCollectionState({
      activeNeed: '',
      selectorOpen: settings.closeSelector ? false : selectorIsOpen(),
      selectorMode: settings.closeSelector ? '' : selectorModeFromState(),
      presetProductIds: []
    });
    restoreProductCount();
    updateShortcutState('');
    updateFacetHiddenInputs('');
    if (settings.updateUrl && currentNeedFromUrl()) setNeedInUrl('', false);
  }

  function applyPresetFromUrl(options) {
    var settings = Object.assign({ closeSelector: true, preserveScroll: false }, options || {});
    if (!isPresetCollection()) return;
    var slug = currentNeedFromUrl();
    if (slug && applyPreset(slug, {
      updateUrl: false,
      closeSelector: settings.closeSelector,
      preserveScroll: settings.preserveScroll
    })) return true;
    clearPreset({ updateUrl: false, closeSelector: settings.closeSelector });
    return false;
  }

  function openSelectorForIntent(intent, options) {
    var selector = selectorRoot();
    var settings = Object.assign({ scroll: true, focus: true, allowPresetIntent: false, mode: '' }, options || {});
    var opened = false;
    var mode = settings.mode || (intent && intent !== 'not-sure' ? 'refine' : 'help');
    if (!selector) return false;
    if (!settings.allowPresetIntent && isPresetIntent(intent)) return false;

    if (window.saCollectionSelectorApi && typeof window.saCollectionSelectorApi.applyCollectionIntent === 'function' && intent) {
      if (window.saCollectionSelectorApi.applyCollectionIntent(intent, {
        root: selector,
        scroll: settings.scroll,
        focus: settings.focus
      })) {
        opened = true;
      }
    }

    if (!opened && window.saCollectionSelectorApi && typeof window.saCollectionSelectorApi.open === 'function') {
      opened = window.saCollectionSelectorApi.open('help', {
        root: selector,
        scroll: settings.scroll,
        focus: settings.focus
      });
    }

    if (!opened) {
      selector.classList.add('is-compact-open');
      selector.setAttribute('data-compact-open', 'true');
      if (settings.scroll) {
        selector.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
      opened = true;
    }

    syncCollectionState({
      selectorOpen: true,
      selectorMode: mode
    });
    updateShortcutState(collectionState.activeNeed);
    return opened;
  }

  function toggleHelpSelector() {
    var helpOpen = (collectionState.selectorOpen || selectorIsOpen()) && selectorModeFromState() === 'help' && !collectionState.activeNeed;
    if (helpOpen) {
      closeSelector();
      setNeedInUrl('', false, {
        saNeed: '',
        saSelectorOpen: false,
        saSelectorMode: ''
      });
      return;
    }

    clearPreset({ updateUrl: false, closeSelector: false });
    if (openSelectorForIntent('not-sure', { scroll: true, focus: true, mode: 'help' })) {
      setNeedInUrl('', false, {
        saNeed: '',
        saSelectorOpen: true,
        saSelectorMode: 'help'
      });
    }
  }

  function openRefineSelector() {
    if (!activeNeedSlug) return;
    if (openSelectorForIntent(activeNeedSlug, {
      scroll: true,
      focus: true,
      allowPresetIntent: true,
      mode: 'refine'
    })) {
      setNeedInUrl(activeNeedSlug, false, {
        saNeed: activeNeedSlug,
        saSelectorOpen: true,
        saSelectorMode: 'refine'
      });
    }
  }

  function restoreStateFromHistory(event) {
    var historyState = event && event.state ? event.state : {};
    var historySelectorOpen = historyState.saSelectorOpen === true;
    var historySelectorMode = historyState.saSelectorMode || '';
    var slug = currentNeedFromUrl();

    if (slug) {
      var keepSelectorOpen = historySelectorOpen && historySelectorMode === 'refine';
      if (applyPreset(slug, { updateUrl: false, closeSelector: !keepSelectorOpen, preserveScroll: true }) && keepSelectorOpen) {
        openSelectorForIntent(slug, {
          scroll: false,
          focus: false,
          allowPresetIntent: true,
          mode: 'refine'
        });
      }
      return;
    }

    if (historySelectorOpen && historySelectorMode === 'help') {
      clearPreset({ updateUrl: false, closeSelector: false });
      openSelectorForIntent('not-sure', { scroll: false, focus: false, mode: 'help' });
      return;
    }

    clearPreset({ updateUrl: false, closeSelector: true });
  }

  function initNeedShortcuts(root) {
    if (root.dataset.saNeedShortcutsReady === 'true') return;
    root.dataset.saNeedShortcutsReady = 'true';
    normalizeNeedShortcutRail(root);
    updateShortcutState(activeNeedSlug || currentNeedFromUrl());
    normalizeNeedShortcutRail(root);
    root.addEventListener('click', function (event) {
      var shortcut = event.target.closest('[data-sa-intent-shortcut]');
      if (!shortcut) return;
      var intent = shortcut.getAttribute('data-sa-intent') || '';
      claimShortcutEvent(event);

      if (intent === 'not-sure') {
        toggleHelpSelector();
        return;
      }

      if (presetHasProducts(presetForIntent(intent))) {
        applyPreset(intent, { updateUrl: true, preserveScroll: true });
      }
    }, true);
  }

  function answersFromBottomControl(control) {
    var map = [
      ['product_type', 'data-sa-answer-product-type'],
      ['camera_count', 'data-sa-answer-camera-count'],
      ['area', 'data-sa-answer-area'],
      ['use_case', 'data-sa-answer-use-case'],
      ['camera_shape', 'data-sa-answer-camera-shape'],
      ['ir_distance', 'data-sa-answer-ir-distance'],
      ['priority', 'data-sa-answer-priority'],
      ['night', 'data-sa-answer-night']
    ];
    return map.reduce(function (answers, item) {
      var value = control.getAttribute(item[1]);
      if (value) answers[item[0]] = value;
      return answers;
    }, {});
  }

  function initBottomSelectorActions(root) {
    if (root.dataset.saBottomSelectorReady === 'true') return;
    root.dataset.saBottomSelectorReady = 'true';
    root.addEventListener('click', function (event) {
      var control = event.target.closest('[data-sa-bottom-selector]');
      if (!control) return;
      var selector = document.querySelector('[data-sa-collection-selector]');
      if (!selector) return;
      event.preventDefault();

      if (window.saCollectionSelectorApi && typeof window.saCollectionSelectorApi.applyAnswers === 'function') {
        window.saCollectionSelectorApi.applyAnswers(answersFromBottomControl(control), {
          root: selector,
          scroll: true,
          focus: true
        });
        return;
      }

      if (window.saCollectionSelectorApi && typeof window.saCollectionSelectorApi.open === 'function') {
        window.saCollectionSelectorApi.open('help', {
          root: selector,
          scroll: true,
          focus: true
        });
        return;
      }

      selector.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

  ready(function () {
    syncCollectionState({
      activeNeed: currentNeedFromUrl(),
      selectorOpen: selectorIsOpen(),
      selectorMode: selectorIsOpen() ? 'help' : ''
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-sa-popular-carousel]')).forEach(initPopularCarousel);
    Array.prototype.slice.call(document.querySelectorAll('[data-sa-need-shortcuts]')).forEach(initNeedShortcuts);
    Array.prototype.slice.call(document.querySelectorAll('.sa-collection-bottom')).forEach(initBottomSelectorActions);
    applyPresetFromUrl();

    document.addEventListener('sa:collection-grid:rendered', function () {
      window.setTimeout(function () {
        var keepSelectorOpen = collectionState.selectorOpen && (collectionState.selectorMode === 'refine' || collectionState.selectorMode === 'help');
        applyPresetFromUrl({ closeSelector: !keepSelectorOpen, preserveScroll: true });
        if (keepSelectorOpen && collectionState.selectorMode === 'refine' && activeNeedSlug) {
          openSelectorForIntent(activeNeedSlug, {
            scroll: false,
            focus: false,
            allowPresetIntent: true,
            mode: 'refine'
          });
        }
      }, 0);
    });

    window.addEventListener('popstate', function (event) {
      window.setTimeout(function () {
        restoreStateFromHistory(event);
      }, 0);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-sa-need-preset-clear]')) {
        claimShortcutEvent(event);
        clearPreset({ updateUrl: true, closeSelector: true });
        return;
      }

      if (event.target.closest('[data-sa-need-preset-refine]')) {
        claimShortcutEvent(event);
        openRefineSelector();
      }
    });
  });
})();
